var _defs, _path, _path2, _path3, _path4, _g, _g2, _g3, _g4, _path5, _path6, _path7, _path8;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgImgRomantic(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 37.55 24.65",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#999;}.cls-2{opacity:0.89;}.cls-3{fill:#ff4a4a;}.cls-4{fill:#ff6464;}.cls-5{fill:#f13e3e;}.cls-6{fill:#ffcdcd;}.cls-7{opacity:0.83;}.cls-8{opacity:0.84;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "img_romantic") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M36.15,39.17l-.09,0a6.71,6.71,0,0,0,0-3.84,6.5,6.5,0,0,1-.5-2.13,5.2,5.2,0,0,1,.5-2.53,3.93,3.93,0,0,0,.4-2.09,2.25,2.25,0,0,0-.2-.77l.08-.05a2.3,2.3,0,0,1,.22.81,3.65,3.65,0,0,1,0,.93,4.7,4.7,0,0,1-.38,1.21,5.48,5.48,0,0,0,0,4.59,5.57,5.57,0,0,1,.29,2.14A6.52,6.52,0,0,1,36.15,39.17Z",
    transform: "translate(-6.45 -16.12)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M30.87,40.77a2.81,2.81,0,0,1-.21-.64,5.25,5.25,0,0,1,0-1.84,7.13,7.13,0,0,1,.62-1.86c.48-1.1,1-2.24.47-3.2A4.65,4.65,0,0,1,31.23,31,4.28,4.28,0,0,1,31.36,30l.09,0a4.79,4.79,0,0,0-.12,1,4.56,4.56,0,0,0,.46,2.17c.52,1,0,2.16-.46,3.28a7.33,7.33,0,0,0-.62,1.83A4.13,4.13,0,0,0,31,40.72Z",
    transform: "translate(-6.45 -16.12)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M20.52,40.08l-.09,0a4.13,4.13,0,0,0-.57-2.82,8.54,8.54,0,0,1-.62-1.68,3.77,3.77,0,0,1,0-2,14.32,14.32,0,0,1,1.17-2.49,3.76,3.76,0,0,0,.45-2.69,2.92,2.92,0,0,0-.44-1.05l.07-.06A2.77,2.77,0,0,1,21,28.36,3.5,3.5,0,0,1,21,29.57a4.56,4.56,0,0,1-.52,1.56C19.34,33.3,19,34,19.34,35.53A8.33,8.33,0,0,0,20,37.19a10.92,10.92,0,0,1,.56,1.46A2.57,2.57,0,0,1,20.52,40.08Z",
    transform: "translate(-6.45 -16.12)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M13.27,38.26a.05.05,0,0,1,0,0,3.63,3.63,0,0,1,.43-2.18,6.53,6.53,0,0,0,.46-1.56,3.08,3.08,0,0,0-.9-1.89,7.17,7.17,0,0,1-.7-1.06,2.81,2.81,0,0,1-.13-1.63,5,5,0,0,1,.23-.87s0,0,.06,0a.05.05,0,0,1,0,.07,5.57,5.57,0,0,0-.23.85,2.82,2.82,0,0,0,.12,1.56,6.61,6.61,0,0,0,.7,1.05,3.18,3.18,0,0,1,.92,2,7.1,7.1,0,0,1-.47,1.58,3.72,3.72,0,0,0-.43,2.12,0,0,0,0,1,0,.06Z",
    transform: "translate(-6.45 -16.12)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "cls-2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M17.47,23.91c-1.13,1.35-3.43,4-5,4a2,2,0,0,1-1-.31,10.52,10.52,0,0,1-2.15-1.87L8.2,24.47c-.83-.89-2.95-3.46-.84-5.6a3.55,3.55,0,0,1,5,0l0,0h0a3.57,3.57,0,0,1,4.84-.18l.2.18A3.69,3.69,0,0,1,17.47,23.91Z",
    transform: "translate(-6.45 -16.12)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M9.19,18.55s-2,.4-2,2.2,1.36,1.43,1.65,1.12.89-1.54,1.54-1.72S11,18.22,9.19,18.55Z",
    transform: "translate(-6.45 -16.12)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M13.36,18.54a1,1,0,0,1,1.5,0c.49.52-.5.3-1,.47S12.9,19,13.36,18.54Z",
    transform: "translate(-6.45 -16.12)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M17.47,23.91c-1.13,1.35-3.43,4-5,4a2,2,0,0,1-1-.31c.15,0,.34,0,.56,0,2,0,4.63-3.44,5.46-5.72a3.8,3.8,0,0,0-.27-3.21l.2.18A3.69,3.69,0,0,1,17.47,23.91Z",
    transform: "translate(-6.45 -16.12)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M13,25.23c-.44,0-1.48.07-1.71-.43a1.66,1.66,0,0,1-.09-.37,14.32,14.32,0,0,1,0-3.4c0-.39.16-.83.64-.83H12c.62,0,.61.61.56,1.06a10,10,0,0,0,0,2.25c0,.21.11.42.36.42h1.23a.6.6,0,0,1,.6.61C14.73,25.23,13.42,25.23,13,25.23Z",
    transform: "translate(-6.45 -16.12)"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    className: "cls-7"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M25.87,23c-1.26,1.23-3.81,3.62-5.35,3.5a2,2,0,0,1-.94-.41A10.1,10.1,0,0,1,17.63,24c-.37-.48-.72-1-1-1.39-.73-1-2.58-3.74-.26-5.66a3.54,3.54,0,0,1,5,.51l0,0h0a3.52,3.52,0,0,1,1.48-.72,3.56,3.56,0,0,1,3.36,1,1.54,1.54,0,0,1,.17.19A3.68,3.68,0,0,1,25.87,23Z",
    transform: "translate(-6.45 -16.12)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M19.37,16.56a2.55,2.55,0,0,0-2.44.58c-.75,1.1.52,1.14.84,1.08a4.29,4.29,0,0,1,1.71-.36C20.38,18,20.7,17.11,19.37,16.56Z",
    transform: "translate(-6.45 -16.12)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M23.24,17a2.66,2.66,0,0,1,2.42.71c.6.72-.92.05-1.81,0S22.32,17.25,23.24,17Z",
    transform: "translate(-6.45 -16.12)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M25.87,23c-1.26,1.23-3.81,3.62-5.35,3.5a2,2,0,0,1-.94-.41l.55.05c2,.23,5-2.95,6-5.12a3.8,3.8,0,0,0,.07-3.22,1.54,1.54,0,0,1,.17.19A3.68,3.68,0,0,1,25.87,23Z",
    transform: "translate(-6.45 -16.12)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M23.52,21.48a2.68,2.68,0,0,1-.34,1,2.26,2.26,0,0,1-.62.71,2.29,2.29,0,0,1-.84.38,2.62,2.62,0,0,1-1,0,2.57,2.57,0,0,1-.93-.32,2.21,2.21,0,0,1-.68-.61,2.33,2.33,0,0,1-.39-.86,2.94,2.94,0,0,1,0-1.07,2.84,2.84,0,0,1,.34-1,2.39,2.39,0,0,1,.62-.71,2.2,2.2,0,0,1,.84-.37,2.67,2.67,0,0,1,1,0,2.63,2.63,0,0,1,.93.32,2.1,2.1,0,0,1,.68.61,2.17,2.17,0,0,1,.38.86A2.78,2.78,0,0,1,23.52,21.48Zm-1.22-.19A1.61,1.61,0,0,0,22.06,20a1.11,1.11,0,0,0-1.49-.23A1.45,1.45,0,0,0,20,20.82a1.87,1.87,0,0,0,.44,1.63,1.07,1.07,0,0,0,1.47-.15A1.89,1.89,0,0,0,22.3,21.29Z",
    transform: "translate(-6.45 -16.12)"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    className: "cls-8"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M35.26,23.82c-.8,1.57-2.44,4.66-3.93,5a1.93,1.93,0,0,1-1-.08,10.35,10.35,0,0,1-2.52-1.34l-1.44-1c-1-.68-3.64-2.7-2.07-5.27a3.55,3.55,0,0,1,4.91-1.14h0a3.56,3.56,0,0,1,4.69-1.27l.22.13A3.69,3.69,0,0,1,35.26,23.82Z",
    transform: "translate(-6.45 -16.12)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M29.72,19.89a2.35,2.35,0,0,1,2.16-.95c.89.17-.61.6-1.29,1.09S29.23,20.65,29.72,19.89Z",
    transform: "translate(-6.45 -16.12)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M26.73,26.22a2.78,2.78,0,0,1-1.5-2c-.09-.9.74.5,1.38,1.08S27.58,26.58,26.73,26.22Z",
    transform: "translate(-6.45 -16.12)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M35.26,23.82c-.8,1.57-2.44,4.66-3.93,5a1.93,1.93,0,0,1-1-.08l.54-.13c1.93-.42,3.73-4.39,4-6.8a3.85,3.85,0,0,0-1-3.07l.22.13A3.69,3.69,0,0,1,35.26,23.82Z",
    transform: "translate(-6.45 -16.12)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M30.57,26.21a1.08,1.08,0,0,1-1-.36,9.78,9.78,0,0,1-1.08-1.63,10.35,10.35,0,0,1-.84-1.75.53.53,0,0,1,0-.47c.17-.36.91-.4,1.23.15a12.32,12.32,0,0,1,.64,1.31c.29.65.56,1.42.79,1.43s.21-.84.2-1.39-.33-2.07.58-2.34h0c.33-.06.57.22.6.56a20.59,20.59,0,0,1,0,2.08,5.75,5.75,0,0,1-.3,1.7A1.21,1.21,0,0,1,30.57,26.21Z",
    transform: "translate(-6.45 -16.12)"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    className: "cls-7"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M42.15,24.32c-1.47,1-4.43,2.84-5.91,2.42a1.85,1.85,0,0,1-.85-.57,10.41,10.41,0,0,1-1.53-2.41c-.27-.55-.52-1.09-.76-1.56-.54-1.09-1.83-4.16.81-5.61A3.55,3.55,0,0,1,38.74,18v0h0a3.59,3.59,0,0,1,4.7,1.22l.13.23A3.69,3.69,0,0,1,42.15,24.32Z",
    transform: "translate(-6.45 -16.12)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M36.39,16.6s-1.8-.64-2.51.71.48,1.67.85,1.58,1.36-.71,2-.55S38,17.2,36.39,16.6Z",
    transform: "translate(-6.45 -16.12)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M40.68,18a2.63,2.63,0,0,1,2.24,1.15c.46.82-.91-.13-1.76-.37S39.73,18,40.68,18Z",
    transform: "translate(-6.45 -16.12)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M42.15,24.32c-1.47,1-4.43,2.84-5.91,2.42a1.85,1.85,0,0,1-.85-.57l.53.15c1.89.6,5.42-2,6.87-3.91a3.82,3.82,0,0,0,.67-3.15l.13.23A3.69,3.69,0,0,1,42.15,24.32Z",
    transform: "translate(-6.45 -16.12)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M38.7,24.22a6.67,6.67,0,0,1-.91-.1,2.76,2.76,0,0,1-1.58-.73,1.32,1.32,0,0,1-.11-.59,6,6,0,0,1,.28-1.68c.18-.65.49-1.7.83-1.89a1.92,1.92,0,0,1,1.16.06,9.59,9.59,0,0,1,1.6.5.41.41,0,0,1,.19.13.26.26,0,0,1,0,.19.63.63,0,0,1-.11.38.42.42,0,0,1-.45.15l-.72-.18c-.31-.09-.74-.28-1,0a.44.44,0,0,0,0,.59.81.81,0,0,0,.34.15l.52.13c.28.07.55.23.48.58a.49.49,0,0,1-.25.34.63.63,0,0,1-.45,0L38,22.12a.66.66,0,0,0-.58.06.47.47,0,0,0-.1.56.91.91,0,0,0,.57.32l1,.25a.45.45,0,0,1,.37.55v0a.45.45,0,0,1-.35.33Z",
    transform: "translate(-6.45 -16.12)"
  }))), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M12.34,27.92s-.71.84-.5,1,1.73.18,1.67-.14-.8-.89-.8-.89Z",
    transform: "translate(-6.45 -16.12)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M20.79,26.44s.71.85.5,1-1.73.18-1.67-.15.81-.88.81-.88Z",
    transform: "translate(-6.45 -16.12)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M30.92,28.91s-.64,1.05-.26,1.21,1.87-.15,1.64-.55a2.42,2.42,0,0,0-.93-.73Z",
    transform: "translate(-6.45 -16.12)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M36.12,26.67s-.91.76-.62,1,1.74.44,1.66,0a2.46,2.46,0,0,0-.62-.94Z",
    transform: "translate(-6.45 -16.12)"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgImgRomantic);
export default __webpack_public_path__ + "static/media/img_romantic.c380620f51cb684a456e11b7c925d2d2.svg";
export { ForwardRef as ReactComponent };